/**
 * @file 判断是否是app内
 */

const UA = typeof window === 'object' && window.self === window ? navigator.userAgent : '';
/**
 * 是否是app
 * @function isInBOX
 * @param {string} ua - 传入的 userAgent，如果不传则取 navigator.userAgent
 * @return { boolean} 判断结果
 * @example
 * inBox()
 */

export default (ua = UA) => {
    const reg = /fcapp/i;
    return reg.test(ua);
};
